import React, { useState } from 'react';
import './MyPost.css';

const MyPost = () => {
  const [posts] = useState([
    {
      id: 1,
      petName: 'Max',
      breed: 'Golden Retriever',
      age: '3 years',
      status: 'Available',
      views: 234,
      inquiries: 12,
      posted: '2 weeks ago',
      image: 'https://images.unsplash.com/photo-1633722715463-d30f4f325e24?w=400'
    },
    {
      id: 2,
      petName: 'Whiskers',
      breed: 'Siamese Cat',
      age: '2 years',
      status: 'Pending',
      views: 156,
      inquiries: 8,
      posted: '1 week ago',
      image: 'https://images.unsplash.com/photo-1513360371669-4adf3dd7dff8?w=400'
    },
    {
      id: 3,
      petName: 'Rocky',
      breed: 'German Shepherd',
      age: '4 years',
      status: 'Adopted',
      views: 445,
      inquiries: 28,
      posted: '3 weeks ago',
      image: 'https://images.unsplash.com/photo-1568572933382-74d440642117?w=400'
    }
  ]);

  return (
    <div className="mypost-page">
      <div className="page-header">
        <div>
          <h1>📝 My Posts</h1>
          <p>Manage your pet listings and track their performance</p>
        </div>
        <button className="add-post-btn">➕ Add New Post</button>
      </div>

      <div className="posts-stats">
        <div className="stat-box">
          <span className="stat-label">Total Posts</span>
          <span className="stat-value">{posts.length}</span>
        </div>
        <div className="stat-box">
          <span className="stat-label">Total Views</span>
          <span className="stat-value">{posts.reduce((sum, p) => sum + p.views, 0)}</span>
        </div>
        <div className="stat-box">
          <span className="stat-label">Total Inquiries</span>
          <span className="stat-value">{posts.reduce((sum, p) => sum + p.inquiries, 0)}</span>
        </div>
      </div>

      <div className="posts-list">
        {posts.map(post => (
          <div key={post.id} className="post-card">
            <img src={post.image} alt={post.petName} className="post-image" />
            <div className="post-content">
              <div className="post-header">
                <div>
                  <h3>{post.breed} - {post.petName}</h3>
                  <p className="post-age">🎂 {post.age}</p>
                </div>
                <span className={`status-badge ${post.status.toLowerCase()}`}>
                  {post.status}
                </span>
              </div>

              <div className="post-stats">
                <div className="post-stat">
                  <span className="stat-icon">👁️</span>
                  <span>{post.views} views</span>
                </div>
                <div className="post-stat">
                  <span className="stat-icon">💬</span>
                  <span>{post.inquiries} inquiries</span>
                </div>
                <div className="post-stat">
                  <span className="stat-icon">📅</span>
                  <span>Posted {post.posted}</span>
                </div>
              </div>

              <div className="post-actions">
                <button className="action-btn edit">✏️ Edit</button>
                <button className="action-btn view">👁️ View</button>
                <button className="action-btn delete">🗑️ Delete</button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {posts.length === 0 && (
        <div className="empty-state">
          <span className="empty-icon">📝</span>
          <h3>No posts yet</h3>
          <p>Start by creating your first pet listing</p>
          <button className="add-post-btn">➕ Create First Post</button>
        </div>
      )}
    </div>
  );
};

export default MyPost;
